import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SEOManager } from '../utils/SEOManager';

interface SEOHeadProps {
  page: string;
  restaurant?: any;
}

export function SEOHead({ page, restaurant }: SEOHeadProps) {
  const { i18n } = useTranslation();
  const seoManager = SEOManager.getInstance();

  useEffect(() => {
    const language = i18n.language;
    const seoData = seoManager.getSEODataForPage(page, language);
    
    // If we're on a restaurant page, add restaurant-specific data
    if (restaurant) {
      seoData.title = `${restaurant.name} - ${seoData.title}`;
      seoData.description = `${restaurant.name} in ${restaurant.deelgemeente}. ${seoData.description}`;
      seoData.structuredData = seoManager.getRestaurantStructuredData(restaurant);
    }

    seoManager.updateMetaTags(seoData, language);
  }, [page, restaurant, i18n.language]);

  return null;
}